import React from 'react';

import { Box, BoxProps, Flex, Space, Title, TitleOrder } from '@mantine/core';

interface SettingsSectionWrapperProps extends BoxProps {
  title: string;
  icon?: React.ReactNode;
  titleNextComponent?: React.ReactNode;
  rightComponent?: React.ReactNode;
  leftComponent?: React.ReactNode;
  titleOrder?: TitleOrder;
  children: React.ReactNode;
}

export function SettingsSectionWrapper({
  title,
  icon,
  titleNextComponent,
  rightComponent,
  titleOrder = 4,
  children,
  ...boxProps
}: SettingsSectionWrapperProps) {
  return (
    <Flex direction="column" {...boxProps}>
      <Flex direction="row" align="center" justify="space-between" mb={10} mt={5}>
        <Flex direction="row" align="center">
          {icon && (
            <>
              {icon}
              <Space w={7} />
            </>
          )}
          <Title order={titleOrder}>{title}</Title>
          <Space w={7} />
          {titleNextComponent}
        </Flex>
        {rightComponent}
      </Flex>
      <Box style={{ overflow: 'hidden', flexGrow: 1 }}>{children}</Box>
    </Flex>
  );
}
